import { render } from "./System.vue?vue&type=template&id=742d759e&scoped=true&ts=true"
import script from "./System.vue?vue&type=script&lang=ts"
export * from "./System.vue?vue&type=script&lang=ts"

import "./System.vue?vue&type=style&index=0&id=742d759e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-742d759e"]])

export default __exports__